import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { ui } from "@/lib/ui";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/websites");
    } catch (err) {
      setError(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-slate-950">
      <div className="w-full max-w-md animate-fade-up">
        <div className="mb-8 text-center">
          <div className="text-3xl font-black tracking-tight bg-gradient-to-r from-slate-100 via-indigo-200 to-indigo-400 bg-clip-text text-transparent font-h">OpusOS</div>
          <div className="text-[11px] font-mono tracking-widest uppercase text-slate-500 mt-1">Operations Hub</div>
        </div>

        <form onSubmit={submit} className={`${ui.card} p-8`} data-testid="login-form">
          <h1 className="text-xl font-bold text-slate-100 font-h mb-1">Sign in</h1>
          <p className="text-sm text-slate-400 mb-6">Accounts are created by an administrator.</p>

          <div className="mb-4">
            <label className={ui.label} htmlFor="email">Email</label>
            <input id="email" data-testid="login-email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} className={ui.input} placeholder="you@company.com" />
          </div>
          <div className="mb-5">
            <label className={ui.label} htmlFor="password">Password</label>
            <input id="password" data-testid="login-password" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} className={ui.input} placeholder="••••••••" />
          </div>

          {error && <div data-testid="login-error" className="mb-4 text-sm text-rose-400 bg-rose-950/40 border border-rose-500/30 rounded-lg px-3 py-2">{error}</div>}

          <button type="submit" data-testid="login-submit" disabled={loading} className={`${ui.btnPrimary} w-full`}>
            {loading ? <Loader2 className="w-4 h-4 spin" /> : null} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
